<template>
  <a :href="href" :class="['t-link', baseClass]" @click="handleClick">
    <span class="t-label">
      <span :class="['t-icon-spot', iconClass]"></span>
      <span class="t-label-text"><slot></slot></span>
    </span>
  </a>
</template>

<script>
import BaseMixin from './BaseMixin.vue'

export default {
  name: 'IconLink',

  mixins: [BaseMixin],

  props: {
    href: {
      type: String,
      default: '#',
    },
  },

  methods: {
    handleClick(e) {
      if (this.href === '#') {
        e.preventDefault()
        this.$emit('click', e)
      }
    },
  },
}
</script>
